import { ReactNode } from "react";
import { Box } from "@mui/material";
import AppBar from "./AppBar";
import SetupChecklist from "../onboarding/SetupChecklist";

interface LayoutProps {
  children: ReactNode;
  pageTitle?: string;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar />
      <Box
        component="main"
        sx={{
          p: 2,
          mt: 8,
          width: "100%",
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
      <SetupChecklist />
    </Box>
  );
}
